module.exports = __webpack_public_path__ + "img/product-32.182abf91.jpg";